export const FETCH_LEAVE_ADJUSTMENTS_REQUEST = "FETCH_LEAVE_ADJUSTMENTS_REQUEST";
export const FETCH_LEAVE_ADJUSTMENTS_SUCCESS = "FETCH_LEAVE_ADJUSTMENTS_SUCCESS";
export const FETCH_LEAVE_ADJUSTMENTS_FAIL = "FETCH_LEAVE_ADJUSTMENTS_FAIL";

export const ADD_LEAVE_ADJUSTMENT_REQUEST = "ADD_LEAVE_ADJUSTMENT_REQUEST";
export const ADD_LEAVE_ADJUSTMENT_SUCCESS = "ADD_LEAVE_ADJUSTMENT_SUCCESS";
export const ADD_LEAVE_ADJUSTMENT_FAIL = "ADD_LEAVE_ADJUSTMENT_FAIL";

export const CLEAR_LEAVE_ADJUSTMENTS = "CLEAR_LEAVE_ADJUSTMENTS";